export default __webpack_public_path__ + "OpenSans-Italic-20653d2fac6285bf4deac9919fcb434d.ttf";